import { createContext, useContext } from 'react'

export const HistoryContext = createContext()

export function useHistory() {
  return useContext(HistoryContext)
}
